<script>
    import { createEventDispatcher } from "svelte";
    import { intToEuro } from "../../../utils/utils";
    import Fa from "svelte-fa";
    import { faPen, faTrash, faX } from "@fortawesome/free-solid-svg-icons";
    import Button from "../../ui/Button.svelte";
    import EditReward from "./EditReward.svelte";


    export let reward;
    export let type;
    reward = reward ?? {};

    const dispatch = createEventDispatcher();

    function remove () {
        dispatch("remove", reward)
    }
</script>

<div class="reward">
    <div class="header">
        <span class="name">
            {#if reward.count}
                {reward.count}x
            {/if}
            {#if reward.type == "cash_voucher"}
                Wertgutschein: {intToEuro(reward.value)}
            {:else if reward.type == "product_voucher"}
                Sachgutschein: {reward.name??"Produkt"}
            {:else if reward.type == "product"}
                Gratisprodukt: {reward.name??"Produkt"}
            {/if}
        </span>
        <div class="actions">
            <EditReward
                bind:reward {type} on:edit={(e) => dispatch("edit", reward)}
            />
            <Button type="button" transparent on:click={remove}>
                <Fa
                    slot="icon"
                    icon={faTrash}
                />
            </Button>
        </div>
    </div>
    {#if reward.description}
        <div class="content">
            <span>{reward.description}</span>
        </div>
    {/if}
</div>

<style>
    .reward {
        background-color: #E0D8D2;
        border-radius: 0.5rem;
        display: flex;
        flex-direction: column;
    }

    
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        padding: 0.5rem 1rem 0.5rem 1rem;
    }

    .actions {
        margin: -0.5rem -1rem;
    }

    .content {
        margin-top: -0.25rem;
        padding: 0 1rem 1rem 1rem;
        font-size: 0.8rem;
    }
</style>